import { gql } from '@apollo/client';

export const UPDATE_LINEUP = gql`
  mutation UpdateLineup($input: UpdateLineupInput!) {
    updateLineup(input: $input) {
      errors
    }
  }
`;
